
import { View, Model } from 'backbone';

import _template from 'properties/main/encrypt.ejs';
import util     from 'util/Util.js';
import accountService   from 'AccountService.js';
import AlertDialogView   from 'common-views/AlertDialogView.js';
import constants from 'Constants.js';
import listService from 'ListService';

class MainEncryptView extends View {

    initialize( opts ) {
        this.options = opts || {};
        this.template = _template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change input[type=checkbox]' : 'updateCheckAttributes'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

    updateCheckAttributes(ev) {
        ev.preventDefault();
        const propVal  = ev.currentTarget.checked;
        const propName = ev.currentTarget.name;

        if (propVal) {
            accountService.verifyEncrypted().then((hasEncrypted) => {
                if (!hasEncrypted) {
                    // display Alert about missing feature.
                    this.dialog = util.newDashboardModal("#featureDisabled", 
                    {
                        title: "Encryption Feature Not Enabled", 
                        hideTitleBar: false, 
                        closeEsc: true, 
                        width: 515,
                        titleBarClass: "dashboard-modal-dialog-titlebar-notification",
                        titleClass: "dashboard-modal-title-notification",
                        buttons:  [{
                            text: 'Ok',
                            'class':'btn-select-field',
                            click: () => {
                                this.dialog.dialog("close");
                            }
                        }]
                    }).dialog("open");
                    this.dialog.dialog( "option", "position", { my: "center center-150", at: "center", of: window } );          
                    $(`input[name='encrypt']`).prop('checked', false );
                } else {
                    this.model.set(propName, propVal);
                }
            });
        } else {
            this.model.set( propName, propVal );
        }


    }

    render() {
        this.$el.empty();
        if(this.template) {
            //console.log(this.getViewValues());
            this.$el.html(this.template(this.model.toJSON()));
        }

        let encrypt = util.isTrue(this.model.get('encrypt'));
        $(`input[name='encrypt']`).prop('checked', encrypt );

        this.delegateEvents();
        return this;
    }

}

export default MainEncryptView;
